import React, { useEffect, useState } from "react";
import { BrowserRouter as Router, useLocation } from "react-router-dom";
import Navbar from "./components/Navbar";
import { LanguageProvider } from "./LanguageContext";
import CustomScrollbar from "./components/CustomScrollbar";
import Loader from "./components/Loader";
import AppRouter from "./AppRouter";
import { ConfigProvider } from "./config";
import AdminRouter from "./admin/AdminRouter";
import {axiosInstance} from "./helper/axiosInstance";

function AppContent() {
    const location = useLocation();
    const isAdminRoute = location.pathname.startsWith("/admin");

    return (
        <>
            {!isAdminRoute && <Navbar />}
            {!isAdminRoute && <CustomScrollbar />}
            {isAdminRoute ? <AdminRouter /> : <AppRouter />}
        </>
    );
}

function App() {
    const [isLoading, setIsLoading] = useState(true);
    const [texts, setTexts] = useState({});

    useEffect(() => {
        const minDelay = new Promise(resolve => setTimeout(resolve, 1000));

        const dataFetch = axiosInstance.get("/translate")
            .then((response) => {
                setTexts(response.data[0].data);
                return axiosInstance.get("/blocks");
            })
            .then((response) => {
                setTexts(prev => ({ ...prev, images: response.data[0] }));
            });

        Promise.all([minDelay, dataFetch]).then(() => setIsLoading(false));
    }, []);

    if (isLoading) {
        return <Loader />;
    }

    return (
        <LanguageProvider data={texts}>
            <ConfigProvider>
                <Router basename="/">
                    <AppContent />
                </Router>
            </ConfigProvider>
        </LanguageProvider>
    );
}

export default App;
